// extracted by mini-css-extract-plugin
export default {"FlexContainer":"FlexContainer_FlexContainer__3k-CJ","row":"FlexContainer_row__w+cSs","column":"FlexContainer_column__DjxHm"};